module.exports = __webpack_public_path__ + "img/logo-SAFEST_hi-res.c60b5a09.jpg";